import { observable, computed } from "mobx";
import ContainersService from "../../../../services/ContainersService";
import _ from "lodash";
import {Col} from "reactstrap";
import ContainerItem from "../components/ContainerItem";
import React from "react";

export default class ContainersStore {

    @observable containers;
    @observable paginaAtual;
    @observable itensNaPagina;
    @observable filtro;
    @observable loading;
    @observable buscaVazia;
    @observable buscaSemParametro;
    @observable total

    constructor() {
        this.containers = [];
        this.paginaAtual = 0;
        this.itensNaPagina = 20;
        this.filtros = [];
        this.filtro = "";
        this.loading = false;
        this.buscaVazia = false;
        this.buscaSemParametro = false;
        this.filtrado = false;
        this.total = null

        this.filtrosTela = {}
        this.filtrosTela.container = null;
        this.filtrosTela.booking = null;
        this.filtrosTela.notaFiscal = null;

        this.service = new ContainersService();
    }

    @computed get numeroPaginas(){
        return Math.ceil(this.containers.length / this.itensNaPagina) ;
    }

    listarContainers = () => {
        let itens = [];

        if(_.get(this, "containers")) {
            let lista = this.containers;
            lista.slice(
                this.paginaAtual * this.itensNaPagina,
                (this.paginaAtual + 1) * this.itensNaPagina
            ).forEach((c, i) => {
                itens.push(
                    <Col xl={3} lg={6} md={6}
                    className="col-5x-2">
                        <ContainerItem key={i + this.paginaAtual*this.numeroPaginas} container={c} filtros={this.filtrosTela}/>
                    </Col>
                    );
            })
        }

        return itens;
    };
    
    adicionarFiltro = (campoBusca, valor) => {
        let minValor
        if(typeof(valor) === 'string'){
            minValor = valor.toUpperCase()
            minValor = minValor.replace(/[ ]/g,'')
        }else{
            minValor = valor
        }
        this.filtros[campoBusca] = minValor;
        this.filtro = "";        
        if(this.filtros['Cntr'])
        {
            this.filtro += "cntrNbr="+this.filtros['Cntr']+"&";
            this.filtrosTela.container = this.filtros['Cntr'];
        }
        if(this.filtros['BookingNbr'])
        { 
            this.filtro += "BookingNbr="+this.filtros['BookingNbr']+"&";
            this.filtrosTela.booking = this.filtros['BookingNbr'];
        }
        if(this.filtros['NotaFiscalTranspNum'])
        {
            this.filtro += "nfNum="+this.filtros['NotaFiscalTranspNum']+"&";
            this.filtrosTela.notaFiscal = this.filtros['NotaFiscalTranspNum'];
        }
        
        this.filtro = this.filtro.substr(0, this.filtro.length-1);
    };
    
    listar = (e) => {
        this.filtrado = true;
        this.loading= true;

        if(_.isEmpty(this.filtro)){
            this.filtrado = false
            this.loading = false;
            this.buscaSemParametro = true;
            this.buscaVazia = false;
            return;
        }else{
            this.buscaSemParametro = false;
        }

        const loadingPromises = Promise.all([
            this.service.listar(this.filtro).then((response) => {
                this.containers = response.data;
                this.total = response.data.length
                if(response.data.length>0) {
                    this.buscaVazia = false;
                }else {
                    this.filtrado = false
                    this.buscaVazia = true;
                    this.buscaSemParametro = false;
                }
            }).catch(error => {
                console.log(error);
            }),
        ]);
        loadingPromises.then(
            () => this.loading = false
        ).catch(
            () => this.loading = false
        )
    }

}


// WEBPACK FOOTER //
// ./src/modules/consultas/containers/stores/ContainersStore.js